import { TableHead, TableRow, TableCell } from '@mui/material'
import { useTranslation } from 'react-i18next'

const columnNames = [
  'id',
  'date',
  'reimbursementType',
  'amount',
  'description',
  'status',
  'researcher',
  'createdAt',
]

export const ExpensesDeclarationTableHead = (): JSX.Element => {
  const { t } = useTranslation('expensesDeclaration')

  return (
    <TableHead sx={{ borderRadius: 8 }}>
      <TableRow>
        {columnNames.map((columnName) => (
          <TableCell key={columnName}>
            {t(`columnNames.${columnName}`)}
          </TableCell>
        ))}
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
